<template>
  <div>
    <v-tabs
      ref="tabs"
      v-model="active"
    >
      <v-tab
        v-for="item in tabItems"
        :key="item.name"
        class="divider font-black"
      >
        {{ item.name }}
      </v-tab>
    </v-tabs>

    <div
      v-if="loading"
      align="center" 
      justify="center"
    >
      <v-progress-linear
        indeterminate
        color="primary"
      />
    </div> 
    <div v-else>
      <v-tabs-items
        v-model="active"
        style="background:transparent"
      >
        <!-- Payment-->
        <v-tab-item>
          <v-autocomplete
            v-model="paymentReport"
            label="Report Types"
            :items="paymentReports"
            item-text="name"
            class="pt-5 px-3"
            style="background:white"
            autofocus
          />

          <payroll-report-export-to-bank
            v-if="paymentReport === 'Export To Bank'"
            :payroll-periods="payrollPeriods"
            :companies="companies"
            class="mb-2"
          />
          <lhdn
            v-if="paymentReport === 'EPF Form A / EIS Import / SOCSO Import / CP39 / RHB Import'"
            :payroll-periods="payrollPeriods"
            class="mb-2"
          />
          <payment-summary
            v-if="paymentReport === 'Payment Summary'"
            :payroll-periods="payrollPeriods"
            class="mb-2"
          />
          <payroll-bank-credit-detail-report
            v-if="paymentReport === 'Payment Bank Credit Details Report'"
            :payroll-periods="payrollPeriods"
            :companies="companies"
            class="mb-2"
          />
        </v-tab-item>
      </v-tabs-items>
    <!-- -->
    </div>
  </div>
</template>

<script>
  export default {
    components: {
      PayrollReportExportToBank: () => import('@/components/hris/payroll/report/payment/ExportToBank'),
      Lhdn: () => import('@/components/hris/payroll/report/payment/Lhdn'),
      PaymentSummary: () => import('@/components/hris/payroll/report/payment/PaymentSummary'),
      PayrollBankCreditDetailReport: () => import('@/components/hris/payroll/report/payment/PayrollBankCreditDetailReport'),
    },

    data () {
      return {
        tabItems: [
          { name: 'Payment' },
        ],
        active: 0,
        loading: false,
        companies: [],
        payrollPeriods: [],
        paymentReport: null,
        paymentReports: [
          { name: 'Export To Bank' },
          { name: 'EPF Form A / EIS Import / SOCSO Import / CP39 / RHB Import' },
          { name: 'Payment Summary' },
          { name: 'Payment Bank Credit Details Report' },
        ],
      }
    },
    created () {
      this.loading = true
        
      Promise.all([
        this.$api.hrisCompanies().list(),
        this.$api.payrollPeriods().list(),
      ])
        .then(([companies, payrollPeriods]) => {
          this.companies = _.orderBy(companies.data, ['name'], ['asc'])
          this.companies.unshift({ id: 'ALL', name: 'All Companies' })
          
          this.payrollPeriods = _.orderBy(
            payrollPeriods.data.filter(period => period.payroll_cycle_transactions.length > 0),
            ['payroll_date'],
            ['desc']
          )

          this.loading = false
        })
    },
  }
</script>
